export const config = (onView, withFilter) => [
  {
    name: "Numéro contrat",
    selector: (row) => row.contract_number,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Etat du contrat",
    selector: (row) => row.status,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Montant de financement",
    selector: (row) => row.amount,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.amount === 0 ? "" : row.amount),
  },

  {
    name: "Matériel",
    selector: (row) => row.project,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Date fin du contrat",
    selector: (row) => row.effective_date,
    sortable: true,
    filterable: withFilter,
  },
];
